/* =========================================================================
   hh-howto.js — "How to use your products" page controller.
   Vanilla-JS. No innerHTML anywhere — all DOM built via h() / textContent.

   Data input:
     [data-hh-howto-catalogue]  — JSON array from Shopify metafields
     [data-hh-howto-config]     — JSON: title, subtitle, closingNote, contactUrl
   ========================================================================= */
(function () {
  'use strict';

  var HOWTO_PAGE_MAX = 820; // narrow reading/reference column (matches mockup)

  // Map product.type → group.  Products whose type isn't listed → "More".
  var HOWTO_GROUPS = [
    { key: 'skincare',  label: 'Skincare & Body',  types: ['Body oil', 'Tallow balm', 'Salve'] },
    { key: 'fragrance', label: 'Fragrance',         types: ['Eau de Parfum'] },
    { key: 'hair',      label: 'Hair',              types: ['Hair milk'] },
    { key: 'wellness',  label: 'Wellness',          types: ['Roll-on'] },
  ];

  // ---------------------------------------------------------------------------
  // h(tag, props, children[]) — hyperscript helper (mirrors hh-reveal.js).
  // Text via textContent only; no innerHTML anywhere.
  // ---------------------------------------------------------------------------
  function h(tag, props, children) {
    var el = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (v == null) return;
        if (k === 'class')  { el.className = v; return; }
        if (k === 'text')   { el.textContent = v; return; }
        if (k.indexOf('on') === 0 && typeof v === 'function') {
          el.addEventListener(k.slice(2).toLowerCase(), v);
          return;
        }
        el.setAttribute(k, v);
      });
    }
    (children || []).forEach(function (c) {
      if (c == null || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }

  // svgEl(tag, attrs) — SVG-namespaced element builder (no innerHTML).
  function svgEl(tag, attrs) {
    var NS = 'http://www.w3.org/2000/svg';
    var el = document.createElementNS(NS, tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (attrs[k] != null) el.setAttribute(k, attrs[k]);
      });
    }
    return el;
  }

  // Close × SVG
  function makeClearSvg() {
    var svg = svgEl('svg', { viewBox: '0 0 24 24', width: '20', height: '20',
      fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4', 'stroke-linecap': 'round',
      'aria-hidden': 'true' });
    var l1 = svgEl('line', { x1: '5', y1: '5', x2: '19', y2: '19' });
    var l2 = svgEl('line', { x1: '19', y1: '5', x2: '5', y2: '19' });
    svg.appendChild(l1);
    svg.appendChild(l2);
    return svg;
  }

  // Thin horizontal rule element (for group heading separators)
  function makeRule() {
    var rule = h('div', { class: 'hh-howto-rule' });
    return rule;
  }

  // ---------------------------------------------------------------------------
  // init — mounts the entire HowTo UI
  // ---------------------------------------------------------------------------
  function init(mount) {
    if (mount.__hhHowtoInit) return;
    mount.__hhHowtoInit = true;

    // ── Parse data ──────────────────────────────────────────────────────────
    var catEl = document.querySelector('[data-hh-howto-catalogue]');
    var cfgEl = document.querySelector('[data-hh-howto-config]');

    if (!catEl || !cfgEl) {
      mount.appendChild(h('p', { class: 'hh-howto-error', text: 'How-to data missing.' }));
      return;
    }

    var catalogue, config;
    try {
      catalogue = JSON.parse(catEl.textContent);
      config    = JSON.parse(cfgEl.textContent);
    } catch (e) {
      mount.appendChild(h('p', { class: 'hh-howto-error', text: 'How-to data could not be parsed.' }));
      return;
    }

    // Normalize: null JSON fields → empty arrays
    catalogue.forEach(function (p) {
      if (!Array.isArray(p.activeIngredients)) p.activeIngredients = [];
      if (!Array.isArray(p.notes))             p.notes = [];
    });

    // Routines (sets tagged `routine`) — optional blob; a parse failure drops the
    // group rather than the whole page. how_to_use is one paragraph per step, paired by
    // position with members (both in application order). A leading "1." is stripped
    // because the number is drawn as a badge.
    var routines = [];
    var rtEl = document.querySelector('[data-hh-howto-routines]');
    if (rtEl) {
      try { routines = JSON.parse(rtEl.textContent) || []; } catch (e) { routines = []; }
    }
    routines.forEach(function (r) {
      if (!Array.isArray(r.members)) r.members = [];
      r.steps = String(r.howToUse || '').split(/\n\s*\n/).map(function (s) {
        return s.replace(/^\s*\d+[.)]\s*/, '').trim();
      }).filter(Boolean).map(function (text, i) {
        return { n: i + 1, text: text, member: r.members[i] || null };
      });
      r.type = r.steps.length + (r.steps.length === 1 ? ' step' : ' steps');
    });

    // ── Group products ───────────────────────────────────────────────────────
    function groupOf(p) {
      for (var gi = 0; gi < HOWTO_GROUPS.length; gi++) {
        if (HOWTO_GROUPS[gi].types.indexOf(p.type) !== -1) return HOWTO_GROUPS[gi].key;
      }
      return 'more';
    }

    var allGroups = HOWTO_GROUPS.concat([{ key: 'more', label: 'All Products', types: [] }]);
    var groups = allGroups
      .map(function (g) {
        return { key: g.key, label: g.label, items: catalogue.filter(function (p) { return groupOf(p) === g.key; }) };
      })
      .filter(function (g) { return g.items.length > 0; });

    // Routines lead the page: they're the "start here" answer for anyone holding a set.
    if (routines.length > 0) {
      groups.unshift({ key: 'routines', label: 'Routines', items: [], routines: routines });
    }

    // ── Mutable UI state ─────────────────────────────────────────────────────
    var query        = '';    // search input value
    var openId       = null;  // handle of the open card (one at a time)
    var inciOpenId   = null;  // handle of the open INCI panel (nested)
    var activeGroup  = groups.length > 0 ? groups[0].key : null;

    // DOM refs for scroll-spy
    var barEl        = null;  // sticky control bar
    var sectionEls   = {};    // { groupKey: sectionEl }
    var ioInstance   = null;  // IntersectionObserver

    // ── Search helpers ───────────────────────────────────────────────────────
    function matches(p, q) {
      if (!q) return true;
      var haystack = [p.name, p.type].concat(p.notes || []).filter(Boolean).join(' ').toLowerCase();
      return haystack.indexOf(q) !== -1;
    }

    // ── Chip ─────────────────────────────────────────────────────────────────
    function makeChip(group) {
      var isActive = (activeGroup === group.key);
      var btn = h('button', {
        type: 'button',
        class: 'hh-howto-chip' + (isActive ? ' hh-howto-chip--active' : ''),
        text: group.label,
        onclick: function () {
          activeGroup = group.key;
          // jump to section with sticky-bar offset
          var target = sectionEls[group.key];
          if (target && barEl) {
            var top = target.getBoundingClientRect().top + window.scrollY - barEl.offsetHeight - 12;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
          rerenderBar();
        },
      });
      return btn;
    }

    // ── +/− affordance SVG ───────────────────────────────────────────────────
    function makePlusMinus(isOpen) {
      var wrap = h('span', { class: 'hh-howto-card__pm', 'aria-hidden': 'true' });
      // horizontal bar (always visible)
      var horiz = h('span', { class: 'hh-howto-card__pm-h' });
      // vertical bar (hidden when open)
      var vert  = h('span', { class: 'hh-howto-card__pm-v' + (isOpen ? ' hh-howto-card__pm-v--hidden' : '') });
      wrap.appendChild(horiz);
      wrap.appendChild(vert);
      return wrap;
    }

    // ── INCI count helper ────────────────────────────────────────────────────
    function inciCount(inci) {
      if (!inci) return 0;
      return inci.split(',').length;
    }

    // ── Product card ─────────────────────────────────────────────────────────
    function makeCard(p) {
      var isOpen   = (openId === p.id);
      var inciOpen = (inciOpenId === p.id);

      // Row: tap target to open/close
      var thumbEl = h('div', { class: 'hh-howto-card__thumb' });
      if (p.image) {
        thumbEl.appendChild(h('img', { src: p.image, alt: '', class: 'hh-howto-card__thumb-img' }));
      }

      var nameEl = h('div', { class: 'hh-howto-card__name', text: p.name });
      var typeEl = h('div', { class: 'hh-howto-card__type', text: p.type });

      var metaEl = h('div', { class: 'hh-howto-card__meta' }, [nameEl, typeEl]);

      var pmEl = makePlusMinus(isOpen);

      var rowBtn = h('button', {
        type: 'button',
        class: 'hh-howto-card__row',
        'aria-expanded': isOpen ? 'true' : 'false',
        onclick: function () {
          if (openId === p.id) {
            openId = null;
          } else {
            openId = p.id;
          }
          inciOpenId = null;
          rerender();
        },
      }, [thumbEl, metaEl, pmEl]);

      var card = h('div', { class: 'hh-howto-card' });
      card.appendChild(rowBtn);

      if (isOpen) {
        var bodyEl = h('div', { class: 'hh-howto-card__body' });

        // How to use
        var howToSection = h('div', { class: 'hh-howto-card__section' });
        howToSection.appendChild(h('div', { class: 'hh-howto-card__label', text: 'How to use' }));
        howToSection.appendChild(h('p',   { class: 'hh-howto-card__howto', text: p.howToUse }));
        bodyEl.appendChild(howToSection);

        // Key ingredients
        if (p.activeIngredients.length > 0) {
          var ingSection = h('div', { class: 'hh-howto-card__section' });
          ingSection.appendChild(h('div', { class: 'hh-howto-card__label', text: 'Key ingredients' }));

          var ingList = h('div', { class: 'hh-howto-card__ing-list' });
          p.activeIngredients.forEach(function (ing, i) {
            var numEl    = h('span', { class: 'hh-howto-card__ing-num',  text: String(i + 1).padStart(2, '0') });
            var nameSpan = h('span', { class: 'hh-howto-card__ing-name', text: ing.name });
            var benefitEl= h('span', { class: 'hh-howto-card__ing-benefit', text: '— ' + ing.benefit });
            var textEl   = h('p',   { class: 'hh-howto-card__ing-text' }, [nameSpan, benefitEl]);
            ingList.appendChild(h('div', { class: 'hh-howto-card__ing-row' }, [numEl, textEl]));
          });
          ingSection.appendChild(ingList);
          bodyEl.appendChild(ingSection);
        }

        // Full INCI — inline collapsible (no modal)
        if (p.inci) {
          var count    = inciCount(p.inci);
          var inciWrap = h('div', { class: 'hh-howto-card__inci-wrap' });

          var inciBtn = h('button', {
            type: 'button',
            class: 'hh-howto-inci-btn',
            onclick: function () {
              inciOpenId = (inciOpenId === p.id) ? null : p.id;
              rerender();
            },
          });
          inciBtn.textContent = inciOpen
            ? 'Hide full ingredient list'
            : 'Full ingredient list (' + count + ') →';
          inciWrap.appendChild(inciBtn);

          if (inciOpen) {
            var inciPanel = h('div', { class: 'hh-howto-inci-panel' });
            inciPanel.appendChild(h('div', { class: 'hh-howto-inci-panel__label', text: 'Full Ingredients' }));
            inciPanel.appendChild(h('p',   { class: 'hh-howto-inci-panel__text',  text: p.inci }));
            inciWrap.appendChild(inciPanel);
          }

          bodyEl.appendChild(inciWrap);
        }

        // Care note (EDP clarity etc.)
        if (p.care) {
          bodyEl.appendChild(h('p', { class: 'hh-howto-card__care', text: p.care }));
        }

        // Full product details link
        var detailLink = h('a', {
          href: '/products/' + p.id,
          class: 'hh-howto-card__detail-link',
          text: 'Full product details →',
        });
        bodyEl.appendChild(detailLink);

        card.appendChild(bodyEl);
      }

      return card;
    }

    // ── Routine card ─────────────────────────────────────────────────────────
    // Same row/expand shell as makeCard (shares openId, so one card open at a time),
    // but the body is the numbered order of application instead of one how-to.
    function makeRoutineCard(r) {
      var cardId = 'routine:' + r.id;
      var isOpen = (openId === cardId);

      var thumbEl = h('div', { class: 'hh-howto-card__thumb' });
      if (r.image) {
        thumbEl.appendChild(h('img', { src: r.image, alt: '', class: 'hh-howto-card__thumb-img' }));
      }
      var metaEl = h('div', { class: 'hh-howto-card__meta' }, [
        h('div', { class: 'hh-howto-card__name', text: r.name }),
        h('div', { class: 'hh-howto-card__type', text: r.type }),
      ]);

      var rowBtn = h('button', {
        type: 'button',
        class: 'hh-howto-card__row',
        'aria-expanded': isOpen ? 'true' : 'false',
        onclick: function () {
          openId = (openId === cardId) ? null : cardId;
          inciOpenId = null;
          rerender();
        },
      }, [thumbEl, metaEl, makePlusMinus(isOpen)]);

      var card = h('div', { class: 'hh-howto-card hh-howto-card--routine' });
      card.appendChild(rowBtn);

      if (isOpen) {
        var bodyEl = h('div', { class: 'hh-howto-card__body' });
        var section = h('div', { class: 'hh-howto-card__section' });
        section.appendChild(h('div', { class: 'hh-howto-card__label', text: 'In this order' }));

        var list = h('ol', { class: 'hh-howto-steps' });
        r.steps.forEach(function (s) {
          var media = h('div', { class: 'hh-howto-step__media' });
          if (s.member && s.member.image) {
            media.appendChild(h('img', { src: s.member.image, alt: '', class: 'hh-howto-step__img' }));
          }
          var numEl = h('span', { class: 'hh-howto-step__num', 'aria-hidden': 'true', text: String(s.n) });

          var textEl = h('div', { class: 'hh-howto-step__text' });
          if (s.member) {
            textEl.appendChild(h('a', { href: '/products/' + s.member.id, class: 'hh-howto-step__name', text: s.member.name }));
          }
          textEl.appendChild(h('p', { class: 'hh-howto-step__howto', text: s.text }));

          list.appendChild(h('li', { class: 'hh-howto-step', 'aria-label': 'Step ' + s.n }, [numEl, media, textEl]));
        });
        section.appendChild(list);
        bodyEl.appendChild(section);

        bodyEl.appendChild(h('a', {
          href: '/products/' + r.id,
          class: 'hh-howto-card__detail-link',
          text: 'Shop the set →',
        }));
        card.appendChild(bodyEl);
      }
      return card;
    }

    // ── Group section ────────────────────────────────────────────────────────
    function makeGroupSection(group) {
      var section = h('div', { class: 'hh-howto-group', 'data-group': group.key });
      sectionEls[group.key] = section;

      // Heading row: h2 + rule line
      var headRow = h('div', { class: 'hh-howto-group__head' });
      headRow.appendChild(h('h2', { class: 'hh-howto-group__label', text: group.label }));
      headRow.appendChild(makeRule());
      section.appendChild(headRow);

      // Cards
      (group.routines || []).forEach(function (r) {
        section.appendChild(makeRoutineCard(r));
      });
      group.items.forEach(function (p) {
        section.appendChild(makeCard(p));
      });

      return section;
    }

    // ── Search result list ───────────────────────────────────────────────────
    function makeSearchResults(q) {
      var results = catalogue.filter(function (p) { return matches(p, q); });
      var rResults = routines.filter(function (r) { return r.name.toLowerCase().indexOf(q) !== -1; });
      var total = results.length + rResults.length;
      var wrap = h('div', { class: 'hh-howto-search-results' });

      var countEl = h('div', { class: 'hh-howto-search-count',
        text: total + (total === 1 ? ' product' : ' products') });
      wrap.appendChild(countEl);

      if (total > 0) {
        rResults.forEach(function (r) {
          wrap.appendChild(makeRoutineCard(r));
        });
        results.forEach(function (p) {
          wrap.appendChild(makeCard(p));
        });
      } else {
        wrap.appendChild(h('p', { class: 'hh-howto-search-empty',
          text: 'No match. Try the product\'s name — like “Michael” or “Mary’s Gold.”' }));
      }
      return wrap;
    }

    // ── Masthead ─────────────────────────────────────────────────────────────
    function makeMasthead() {
      var section = h('section', { class: 'hh-howto-masthead' });
      section.appendChild(h('h1', { class: 'hh-howto-masthead__title', text: config.title }));
      section.appendChild(h('p',  { class: 'hh-howto-masthead__subtitle', text: config.subtitle }));
      return section;
    }

    // ── Sticky bar (search + chips) ───────────────────────────────────────────
    function makeBar() {
      var bar = h('div', { class: 'hh-howto-bar' });
      barEl = bar;

      var searchWrap = h('div', { class: 'hh-howto-bar__search' });

      var input = h('input', {
        type: 'text',
        class: 'hh-howto-bar__input',
        placeholder: 'Find your product',
      });
      input.addEventListener('input', function () {
        query = input.value.trim().toLowerCase();
        rerenderBody();
        rerenderBar();
      });
      searchWrap.appendChild(input);

      // Clear button — injected into searchWrap on rerender when searching
      var clearBtn = h('button', {
        type: 'button',
        class: 'hh-howto-bar__clear',
        'aria-label': 'Clear search',
        onclick: function () {
          input.value = '';
          query = '';
          rerenderBody();
          rerenderBar();
        },
      });
      clearBtn.appendChild(makeClearSvg());

      searchWrap.appendChild(clearBtn);
      bar.appendChild(searchWrap);

      // Chips row — shown when NOT searching
      var chipsEl = h('div', { class: 'hh-howto-bar__chips' });
      groups.forEach(function (g) {
        chipsEl.appendChild(makeChip(g));
      });
      bar.appendChild(chipsEl);

      return bar;
    }

    // ── Body: groups or search results ───────────────────────────────────────
    var bodyEl = null;

    function buildBody() {
      var el = h('section', { class: 'hh-howto-body' });
      if (query) {
        el.appendChild(makeSearchResults(query));
      } else {
        sectionEls = {};
        groups.forEach(function (g) {
          el.appendChild(makeGroupSection(g));
        });
      }

      // Closing note
      var closingEl = h('div', { class: 'hh-howto-closing' });
      closingEl.appendChild(h('p', { class: 'hh-howto-closing__note', text: config.closingNote }));
      if (config.contactUrl) {
        closingEl.appendChild(h('a', {
          href: config.contactUrl,
          class: 'hh-howto-closing__link',
          text: 'Contact us →',
        }));
      }
      el.appendChild(closingEl);

      return el;
    }

    // ── Re-render helpers ─────────────────────────────────────────────────────

    // Rerender just the bar (chips active state, clear button visibility)
    function rerenderBar() {
      if (!barEl) return;

      // Update clear button visibility
      var clearBtn = barEl.querySelector('.hh-howto-bar__clear');
      if (clearBtn) {
        clearBtn.style.display = query ? '' : 'none';
      }

      // Update chips: hide when searching, update active state when not
      var chipsEl = barEl.querySelector('.hh-howto-bar__chips');
      if (chipsEl) {
        chipsEl.style.display = query ? 'none' : '';
        if (!query) {
          // Update active chip
          var btns = chipsEl.querySelectorAll('.hh-howto-chip');
          for (var i = 0; i < btns.length; i++) {
            var key = groups[i] && groups[i].key;
            if (key === activeGroup) {
              btns[i].classList.add('hh-howto-chip--active');
            } else {
              btns[i].classList.remove('hh-howto-chip--active');
            }
          }
        }
      }
    }

    // Full body rerender (search/group switch, card expand/collapse)
    function rerenderBody() {
      if (!bodyEl || !bodyEl.parentNode) return;
      var newBody = buildBody();
      bodyEl.parentNode.replaceChild(newBody, bodyEl);
      bodyEl = newBody;
      rebindScrollSpy();
    }

    // Light rerender for card expand/collapse (avoids full DOM replacement in search)
    function rerender() {
      rerenderBody();
    }

    // ── Scroll-spy ───────────────────────────────────────────────────────────
    function rebindScrollSpy() {
      if (ioInstance) {
        ioInstance.disconnect();
        ioInstance = null;
      }
      if (query) return; // no spy during search

      var barH = barEl ? barEl.offsetHeight : 0;
      ioInstance = new IntersectionObserver(function (entries) {
        var visible = [];
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.push(e);
        });
        if (!visible.length) return;
        // Pick the section whose top is closest to viewport top
        visible.sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
        var key = visible[0].target.getAttribute('data-group');
        if (key && key !== activeGroup) {
          activeGroup = key;
          rerenderBar();
        }
      }, { rootMargin: '-' + (barH + 8) + 'px 0px -55% 0px', threshold: 0 });

      Object.keys(sectionEls).forEach(function (key) {
        if (sectionEls[key]) ioInstance.observe(sectionEls[key]);
      });
    }

    // ── Mount the UI ─────────────────────────────────────────────────────────
    var wrapper = h('div', { class: 'hh-howto-wrap' });

    wrapper.appendChild(makeMasthead());
    var bar = makeBar();
    wrapper.appendChild(bar);
    // Hide clear button initially (no query)
    var clearBtnInit = bar.querySelector('.hh-howto-bar__clear');
    if (clearBtnInit) clearBtnInit.style.display = 'none';

    bodyEl = buildBody();
    wrapper.appendChild(bodyEl);

    mount.appendChild(wrapper);

    // Kick off scroll-spy after first paint
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () { rebindScrollSpy(); });
    } else {
      rebindScrollSpy();
    }
  }

  // ---------------------------------------------------------------------------
  // boot
  // ---------------------------------------------------------------------------
  function boot() {
    var mount = document.querySelector('[data-hh-howto]');
    if (!mount) return;
    init(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
